import { render, staticRenderFns } from "./collectRecord.vue?vue&type=template&id=27021de2&scoped=true"
import script from "./collectRecord.vue?vue&type=script&lang=js"
export * from "./collectRecord.vue?vue&type=script&lang=js"
import style0 from "./collectRecord.vue?vue&type=style&index=0&id=27021de2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27021de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27021de2')) {
      api.createRecord('27021de2', component.options)
    } else {
      api.reload('27021de2', component.options)
    }
    module.hot.accept("./collectRecord.vue?vue&type=template&id=27021de2&scoped=true", function () {
      api.rerender('27021de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/collectRecord.vue"
export default component.exports